import React, { Fragment, useEffect } from "react";
import IntlMessages from "Util/IntlMessages";
import { Row, Card, CardTitle, Button } from "reactstrap";
import { NavLink } from "react-router-dom";

import { Colxx } from "Components/CustomBootstrap";

function Error404() {
  useEffect(() => {
    document.body.classList.add("background");
    return () => {
      document.body.classList.remove("background");
    };
  }, []);

  return (
    <Fragment>
      <main>
        <div className="container">
          <Row className="h-100">
            <Colxx xxs="12" md="10" className="mx-auto my-auto">
              <Card className="auth-card">
                <div className="bg-404">
                  <div className="form-side mx-auto my-5">
                    <NavLink to={`/`} className="white">
                      <img
                        className="w-250-px  px-2"
                        src="/assets/img/logo-dark.png"
                        alt="Reactify"
                      />
                    </NavLink>
                    <div className="text-center">
                      <p className="display-1 font-weight-bold mb-5">404</p>
                      <Button
                        href="/app"
                        color="primary"
                        className="btn-shadow mb-2"
                        size="lg"
                      >
                        <IntlMessages id="error.go-home" />
                      </Button>
                    </div>
                  </div>
                </div>
              </Card>
            </Colxx>
          </Row>
        </div>
      </main>
    </Fragment>
  );
}

export default Error404;
